import React, {
    useEffect,
    useState,
} from 'react'
import { database } from '../../components/shared/database'
import { processQuerySnapshot } from '../../components/shared/process-query-snapshot'
import OverlayLoader from '../../components/shared/overlay-loader'
import { Link } from 'react-router-dom'

const Recipes = () => {
    const [recipes, setRecipes] = useState()
    const [isLoading, setIsLoading] = useState(false)

    const loadData = () => {
        setIsLoading(true)

        database('recipes')
            .get()
            .then(processQuerySnapshot)
            .then(setRecipes)
            .then(() => setIsLoading(false))
    }

    useEffect(() => {
        loadData()
    }, [])

    const removeRecipe = recipeUid => {
        database('recipes')
            .doc(recipeUid)
            .delete()
            .then(() => loadData())
    }

    return (
        <div className="d-flex flex-column container pt-5">
            <div className="d-flex align-items-center justify-content-between">
                <h2>
                    <Link
                        to="/fridge"
                        className="d-flex align-items-center"
                    >
                        <i className="fas fa-angle-double-left mr-2"></i>

                        Recepty
                    </Link>
                </h2>

                <Link
                    to="/recipes/add"
                    className="btn btn-outline-info btn-sm"
                >
                    <i className="fas fa-plus mr-2"/>
                    Přidat recept
                </Link>
            </div>

            <div className="mt-2">
                {recipes?.map?.(recipe => (
                    <div className="d-flex justify-content-between align-items-center flex-row card p-3">
                        <Link
                            to={`/recipes/${recipe.uid}`}
                            className="d-flex"
                            key={recipe.uid}
                        >
                            {recipe.name}
                        </Link>
                        <div
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => removeRecipe(recipe.uid)}
                        >
                            <i className="fas fa-trash" />
                        </div>
                    </div>
                ))}
            </div>

            {isLoading && <OverlayLoader />}
        </div>
    )
}

export default Recipes
